module.exports = __webpack_public_path__ + "static/media/gp.867af036.png";